<template>
  <DelDialog
    width="740px"
    :dialogVisible="visible"
    @handleClose="handleCancel"
    @handleConfirm="handleConfirm"
  >
    <template #title>{{$t('newProjectV2.uploadTermBank')}}</template>
    <el-upload class="upload-demo" drag action multiple
      :limit="20"
      :accept="acceptStr"
      :file-list="fileList"
      :show-file-list="false"
      :on-change="uploadChange"
      :on-exceed="handleExceed"
      :http-request="uploadSectionFile"
      :before-upload="beforeUploadFile"
    >
      <div class="emptyBox" v-if="fileList.length ? false: true">
        <img style="width: 150px; margin-top: 30px;" src="./assets/images/sc_img.png" alt="">
        <div class="el-upload__text">
          {{$t('newProjectV2.supportFormat', ['xlsx、txt、tbx、zip'])}}
          <em style="display:block">{{$t('newProjectV2.singleFileSize', [50, 20])}}</em>
        </div>
      </div>
      <div v-else class="file-upload-list">
        <el-table
          border
          :data="fileList"
          :height="tableHight"
          header-row-class-name="customHeader"
        >
          <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="100">
            <template slot-scope="{ $index }">
              {{$index + 1}}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.name')"
            align="center"
            prop="name"
          ></el-table-column>
          <el-table-column
            :label="$t('newProjectV2.uploadState')"
            align="center"
          >
            <template slot-scope="{ row }">
              <img :src="isSrc(row)" alt/>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('newProjectV2.operate')"
            align="center"
          >
            <template slot-scope="{ $index }">
              <el-tooltip class="item" effect="dark" :content="$t('newProjectV2.del')" placement="top">
                <i class="el-icon-delete" @click.stop="handleDelete($index)"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-upload>

    <div class="downloadTemplate">
      {{$t('newProjectV2.clickIconDownloadTemp')}}
      <a :href="downloadTemplate('txt')">
        <i class="txt"></i>
      </a>
      <a :href="downloadTemplate('xlsx')">
        <i class="xlsx"></i>
      </a>
      <a :href="downloadTemplate('tbx')">
        <i class="tbx"></i>
      </a>
    </div>
  </DelDialog>
</template>

<script>
import DelDialog from '@/components/delDialog';

import axios from "axios";
import { apiRoot } from '@/services/ajax';
import { getUploadSign } from '@/services/newProjectApi';
import { checkTermFileContent, addTransTermLib } from '@/services/dialogApi';

export default {
  name: 'UploadMemoryBank',
  props: {
    visible: {
      type: Boolean,
      require: true,
    },
    type: {
      type: String,
      default () {
        return '';
      }
    },
    createInfo: {
      type: Object,
      default () {
        return {};
      }
    },
  },
  components: {
    DelDialog
  },
  data () {
    return {
      fileList: [],
      acceptStr: '.xlsx,.txt,.tbx,.zip',
      host: '',
      formData: new FormData(),
      tableHight: '100%',
      fileNameList: [],     // 英文名
      query: {},
      fileName: []          // 中文名
    }
  },
  methods: {
    handleCancel () {
      this.fileList = [];
      this.host = '';
      this.formData = new FormData();
      this.fileNameList = [];
      this.fileName = [];
      this.$emit('handleCancel');
    },
    async handleConfirm () {
      let self = this;
      self.$message.closeAll();
      if (self.fileList.length > 0) {
        if (self.fileNameList.length < self.fileList.length) {
          self.$message.warning(this.$t('newProjectV2.uploadFileTemp'));
          return;
        }
      } else {
        if (self.fileNameList.length < 1) {
          self.$message.warning(this.$t('newProjectV2.uploadFileTip'));
          return;
        }
      }

      let name = /([^\.\/\\]+)\.([a-z]+)$/i.exec(self.fileList[0].name)[1];

      let param = {};

      if (self.type === 'create') {
        self.query = JSON.parse(this.$Base64.decode(this.$route.query.key));

        param = {
          langDesc: self.query.langDesc,
          sentFileUrlList: self.fileNameList,
          sourceLang: self.query.sourceLang,
          targetLang: self.query.targetLang,
          domainCode: self.query.domainCode,
          domainName: self.query.domainName,
          name
        };
      } else if (self.type === 'setting') {
        param = {
          langDesc: this.createInfo.langDesc,
          sentFileUrlList: self.fileNameList,
          sourceLang: this.createInfo.sourceLang,
          targetLang: this.createInfo.targetLang,
          domainCode: this.createInfo.domainCode,
          domainName: this.createInfo.domain,
          name
        }
      } else {
        return;
      }
      let { success, errorDesc } = await addTransTermLib(param);
        self.$message.closeAll();
        if (!success) {
          self.$message.warning(errorDesc);
        } else {
          self.$message.success(this.$t('newProjectV2.uploadSuccess'));
        }
        this.handleCancel();
        this.$emit('updateMemoryBank');
    },
    downloadTemplate (type) {
      return apiRoot('/term/exportTermTemp?type=' + type);
    },
    uploadSectionFile (param) {
      let self = this;
      let file = param.file;

      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();

      getUploadSign({ fileType: "catlib" }).then(({ result }) => {
        self.host = result.host;

        let para = {
          ...result,
          key : `${result.keyPrefix}.${type}`,
          file: param.file,
        };
        Reflect.deleteProperty(para, 'keyPrefix');
        Reflect.deleteProperty(para, 'host');

        self.formData = new FormData();
        Object.keys(para).forEach(function (key) {
          self.formData.append(key, para[key]);
        });

        self.getFileHost(param);

      })
    },
    getFileHost (param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({percent: complete});
        }
      };

      axios.post(FileController, self.formData, config).then((resp) => {
        let { result, success } = resp.data;
        if (!success) {
          return;
        }
        self.getFileContent(result.fileName, param);
        
      });
    },
    getFileContent (fileName, param) {
      let self = this;
      checkTermFileContent({
        fileUrlList: [fileName]
      }).then(({ result }) => {
        if (result.status === 0) {
          self.$message.closeAll();
          self.$message({
            message: result.reason,
            type: 'error'
          });
        }

        self.fileList.forEach(item => {
          if (item.uid === param.file.uid) {
            if (result.status === 0) {
              item.percentage = -1;
            } else {
              this.fileNameList.push(fileName);
              this.fileName.push(param.file.name);
            }
          }
        });
      });
    },
    uploadChange (file) {
      this.fileList.push({
        ...file
      });
    },
    handleExceed () {
      this.$message.closeAll();
      this.$message({
        message: this.$t('newProjectV2.maxFileNum', [20]),
        type: "warning"
      });
    },
    handleDelete (index) {
      let i = this.fileName.indexOf(this.fileList[index].name);
      if (i >= 0) {
        this.fileName.splice(i, 1);
        this.fileNameList.splice(i, 1);
      }

      this.fileList.splice(index, 1);
    },
    beforeUploadFile (file) {
      let re = /([^\.\/\\]+)\.([a-z]+)$/i;
      let resultArr = re.exec(file.name);
      // 文件类型
      let type = resultArr[2].toLocaleLowerCase();
      // 文件是否超过大小
      let isLt20M = file.size / 1024 / 1024 > 50;

      let typeFlag =
        type === "xlsx" ||
        type === "txt" ||
        type === "tbx" ||
        type === "zip";

      if (!typeFlag) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('newProjectV2.onlySupportFormate', ['xlsx、txt、tbx、zip']),
          type: "warning"
        });
        // 去除最后一个文件
        this.fileList.pop();
        return false;
      }

      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('newProjectV2.notSupportEmptyFile'),
          type: "warning"
        });
        return false;
      }

      this.fileList.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.$message.closeAll();
          this.$message({
            message: this.$t('newProjectV2.uploadFileRepeat'),
            type: "warning"
          });
          this.fileList.pop();
          file.obp = true;
          return false;
        }
      });

      if (isLt20M) {
        this.$message.closeAll();
        this.$message({
          message: this.$t('newProjectV2.maxUploadFileSize', [50]),
          type: "warning"
        });
        file.obp = true;
        return false;
      }

      return true;
    },
    isSrc (row) {
      if (row.percentage === 100) {
          return require("./assets/images/uploadSuccess.png");
      } else if (row.percentage === -1) {
          return require("./assets/images/uploadFail.png");
      } else {
          return require("./assets/images/upload_Loading.gif");
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>